// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__pYQNC","footerMain":"Footer_footerMain__ndIg6","whatsApp":"Footer_whatsApp__aL+5W","icons":"Footer_icons__VNCX9"};